var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leads" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-xs-center" },
            [
              _c("v-progress-circular", {
                staticClass: "primary--text",
                attrs: { indeterminate: "", size: 100, width: 1 }
              })
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "v-card",
                { staticClass: "mb-3" },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.leadsDetails2.length
                            ? _c("v-flex", { attrs: { xs3: "", md2: "" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-4 grey--text text--darken-2"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("cap")(_vm.$t("leadsVisitors"))
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "ml-4 headline teal--text" },
                                  [_vm._v(_vm._s(_vm.returningLead))]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", md2: "" } }, [
                            _c(
                              "div",
                              { staticClass: "ml-4 grey--text text--darken-2" },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("cap")(_vm.$t("newLeads")))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-4 headline grey--text" },
                              [_vm._v(_vm._s(_vm.totalLeads))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", md2: "" } }, [
                            _c(
                              "div",
                              { staticClass: "ml-4 grey--text text--darken-2" },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("cap")(_vm.$t("chatsTotal")))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-4 headline grey--text" },
                              [_vm._v(_vm._s(_vm.nbChats))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", md2: "" } }, [
                            _c(
                              "div",
                              { staticClass: "ml-4 grey--text text--darken-2" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("cap")(
                                      _vm.$t("conversionRate") + " chat"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-4 headline primary--text" },
                              [_vm._v(_vm._s(_vm.conversionAgentChat) + " %")]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.brideMenu("stats_chatbot") === "1"
                            ? _c("v-flex", { attrs: { xs6: "", md2: "" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-4 grey--text text--darken-2"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("cap")(
                                          _vm.$t("conversionRate") + " chatbot"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ml-4 headline primary--text"
                                  },
                                  [_vm._v(_vm._s(_vm.conversionBotChat) + " %")]
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "" } },
                            [
                              _c("highcharts", {
                                attrs: { options: _vm.options }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs3: "", md2: "" } }, [
                            _c(
                              "div",
                              { staticClass: "ml-4 grey--text text--darken-2" },
                              [_vm._v(_vm._s(_vm.$t("conseiller")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-4 headline purple--text" },
                              [_vm._v(_vm._s(_vm.totalLeadsAgent))]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.leadsDetails2.length &&
                          _vm.brideMenu("stats_chatbot") === "1"
                            ? _c("v-flex", { attrs: { xs3: "", md2: "" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-4 grey--text text--darken-2"
                                  },
                                  [_vm._v(_vm._s(_vm._f("cap")("(Chatbot)")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "ml-4 headline blue--text" },
                                  [_vm._v(_vm._s(_vm.totalLeadsBot))]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs3: "", md2: "" } }, [
                            _c(
                              "div",
                              { staticClass: "ml-4 grey--text text--darken-2" },
                              [_vm._v(_vm._s(_vm.$t("leadForm")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-4 headline orange--text" },
                              [_vm._v(_vm._s(_vm.totalLeadsForm))]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.brideMenu("stats_callback") === "1"
                            ? _c("v-flex", { attrs: { xs3: "", md2: "" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-4 grey--text text--darken-2"
                                  },
                                  [_vm._v(_vm._s(_vm._f("cap")("(Call back)")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "ml-4 headline brown--text" },
                                  [_vm._v(_vm._s(_vm.totalLeadsC2c))]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brideMenu("parametre_recall") === "1"
                            ? _c("v-flex", { attrs: { xs3: "", md2: "" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-4 grey--text text--darken-2"
                                  },
                                  [_vm._v(_vm._s(_vm._f("cap")("(Meeting)")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ml-4 headline blue-grey--text"
                                  },
                                  [_vm._v(_vm._s(_vm.totalLeadsMeeting))]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs3: "", md2: "" } }, [
                            _c(
                              "div",
                              { staticClass: "ml-4 grey--text text--darken-2" },
                              [_vm._v(_vm._s(_vm.$t("other")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-4 headline green--text" },
                              [_vm._v(_vm._s(_vm.totalLeadsAutre))]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.leadsDetails2.length || _vm.nbCreations
                ? _c(
                    "v-card",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-toolbar",
                            {
                              staticClass: "elevation-0",
                              attrs: { color: "white" }
                            },
                            [
                              _c("v-toolbar-title", [
                                _vm._v(
                                  _vm._s(_vm._f("cap")(_vm.$t("leadsDetails")))
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    dark: "",
                                    flat: "",
                                    disabled: _vm.leadsDetails2.length == 0
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.download()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("exportInCsv")) +
                                      "\n            "
                                  ),
                                  _vm.nbVisits > 500
                                    ? _c(
                                        "v-icon",
                                        {
                                          attrs: { color: "primary", right: "" }
                                        },
                                        [_vm._v("visibility")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          attrs: { color: "primary", right: "" }
                                        },
                                        [_vm._v("file_download")]
                                      )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "mt-2",
                                  attrs: { xs6: "", sm2: "", md3: "" }
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "primary--text returningLeads",
                                    attrs: {
                                      color: "primary",
                                      label: "Returning Leads",
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.sourceReturning,
                                      callback: function($$v) {
                                        _vm.sourceReturning = $$v
                                      },
                                      expression: "sourceReturning"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs6: "", md3: "" } }),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md3: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          items: _vm.motifs,
                                          label: _vm._f("cap")(
                                            _vm.$tc("currentMotif", 2, {
                                              count: ""
                                            })
                                          ),
                                          clearable: "",
                                          "append-icon": "label"
                                        },
                                        model: {
                                          value: _vm.motif,
                                          callback: function($$v) {
                                            _vm.motif = $$v
                                          },
                                          expression: "motif"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md3: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: _vm.$t("search"),
                                          "hide-details": "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs3: "", sm2: "" } },
                                [
                                  _c("v-subheader", {
                                    attrs: { "v-text": _vm.$t("leadFilter") }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              false
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { xs3: "", sm2: "", md1: "" }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "primary--text choixLead",
                                        attrs: {
                                          color: "primary",
                                          label: _vm._f("cap")(
                                            _vm.$tc("leads", 2, { count: "" }) +
                                              " " +
                                              _vm.$t("ofThePeriod")
                                          ),
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.leadsOfPeriod,
                                          callback: function($$v) {
                                            _vm.leadsOfPeriod = $$v
                                          },
                                          expression: "leadsOfPeriod"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "mt-2",
                                  attrs: { xs3: "", sm2: "", md1: "" }
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "primary--text choixLead",
                                    attrs: {
                                      color: "primary",
                                      label: _vm.$t("conseiller"),
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.sourceAgent,
                                      callback: function($$v) {
                                        _vm.sourceAgent = $$v
                                      },
                                      expression: "sourceAgent"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.brideMenu("stats_chatbot") === "1"
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { xs3: "", sm2: "", md1: "" }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "primary--text choixLead",
                                        attrs: {
                                          color: "primary ",
                                          label: "Chatbot ",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.sourceBot,
                                          callback: function($$v) {
                                            _vm.sourceBot = $$v
                                          },
                                          expression: "sourceBot"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "mt-2",
                                  attrs: { xs3: "", sm2: "", md1: "" }
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "primary--text choixLead",
                                    attrs: {
                                      color: "primary",
                                      label: _vm.$t("leadForm"),
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.sourceForm,
                                      callback: function($$v) {
                                        _vm.sourceForm = $$v
                                      },
                                      expression: "sourceForm"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.brideMenu("stats_callback") === "1"
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { xs3: "", sm2: "", md1: "" }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "primary--text choixLead",
                                        attrs: {
                                          color: "primary",
                                          label: _vm._f("cap")(
                                            _vm.$t("callback")
                                          ),
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.C2C,
                                          callback: function($$v) {
                                            _vm.C2C = $$v
                                          },
                                          expression: "C2C"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.brideMenu("parametre_recall") === "1"
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { xs3: "", sm2: "", md1: "" }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "primary--text choixLead",
                                        attrs: {
                                          color: "primary",
                                          label: "Meeting ",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.sourceRecall,
                                          callback: function($$v) {
                                            _vm.sourceRecall = $$v
                                          },
                                          expression: "sourceRecall"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.brideMenu("stats_leads_getquanty") === "1"
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { xs3: "", sm2: "", md1: "" }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "primary--text choixLead",
                                        attrs: {
                                          color: "primary",
                                          label: "GetQuanty ",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.getquanty,
                                          callback: function($$v) {
                                            _vm.getquanty = $$v
                                          },
                                          expression: "getquanty"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headersLeadsDetails,
                              items: _vm.leadsDetails2,
                              "no-data-text": _vm.$tc("leads", 0),
                              "no-results-text": _vm.$tc("results", 0),
                              "rows-per-page-items": [10, 25, 100],
                              "rows-per-page-text": _vm.$t("leadsPerPage"),
                              search: _vm.search,
                              "custom-filter": _vm.filterLeads,
                              "custom-sort": _vm.sort,
                              dark: false,
                              pagination: _vm.pagination
                            },
                            on: {
                              "update:pagination": function($event) {
                                _vm.pagination = $event
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "headerCell",
                                  fn: function(props) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(props.header.text))
                                      ])
                                    ]
                                  }
                                },
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(props.item.creation))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(props.item.last))]
                                        ),
                                        _vm._v(" "),
                                        _vm.brideMenu("stats_leads_chaleur") ===
                                        "1"
                                          ? _c(
                                              "td",
                                              { staticClass: "text-xs-right" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.chaleur(props.item.id)
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.brideMenu(
                                          "stats_leads_getquanty"
                                        ) === "1"
                                          ? _c(
                                              "td",
                                              { staticClass: "text-xs-left" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      props.item.getquanty[
                                                        "raison sociale"
                                                      ]
                                                        ? props.item.getquanty[
                                                            "raison sociale"
                                                          ][1]
                                                        : ""
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(props.item.company))]
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(props.item.gender) +
                                              " " +
                                              _vm._s(props.item.firstName) +
                                              " " +
                                              _vm._s(props.item.lastName) +
                                              " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "font-italic grey--text text--darken-1"
                                            },
                                            [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(props.item.id) +
                                                  ")"
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-right" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("duration")(
                                                  props.item.duration
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.totalSite > 1
                                          ? _c(
                                              "td",
                                              { staticClass: "text-xs-left" },
                                              [_vm._v(_vm._s(props.item.site))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.motifToShow)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.item.source === "rdv"
                                                  ? "meeting"
                                                  : props.item.source
                                              )
                                            ),
                                            _c("br"),
                                            _vm.agentIdToAgentName(
                                              props.item.agent
                                            )[0] !== ""
                                              ? _c("i", [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm.agentIdToAgentName(
                                                          props.item.agent
                                                        )[0]
                                                      ) +
                                                      ")"
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-right px-0" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "", flat: "" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openDialogEdit(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("info_outline")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-right px-0" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "", flat: "" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openDialogRemove(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [_vm._v("delete")])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-right px-0" },
                                          [
                                            _c(
                                              "v-menu",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      slot: "activator",
                                                      icon: "",
                                                      flat: ""
                                                    },
                                                    slot: "activator"
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("share")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list",
                                                  { attrs: { dense: "" } },
                                                  [
                                                    _c(
                                                      "v-list-tile",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.leadMail(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "sendByEmail"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.leadZendesk(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "createAZendeskTicket"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.leadSalesForce(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "exportToSalesForce"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  }
                                },
                                {
                                  key: "pageText",
                                  fn: function(ref) {
                                    var pageStart = ref.pageStart
                                    var pageStop = ref.pageStop
                                    var itemsLength = ref.itemsLength
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(pageStart) +
                                          "-" +
                                          _vm._s(pageStop) +
                                          " sur " +
                                          _vm._s(itemsLength) +
                                          "\n          "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4146217779
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "1200px",
            scrollable: !_vm.$vuetify.breakpoint.smAndDown,
            fullscreen: _vm.$vuetify.breakpoint.smAndDown
          },
          model: {
            value: _vm.dialogEdit,
            callback: function($$v) {
              _vm.dialogEdit = $$v
            },
            expression: "dialogEdit"
          }
        },
        [
          _c("wz-editeur-lead", {
            attrs: {
              leadDialog: _vm.leadDialog,
              custom_motifs: _vm.custom_motifs,
              custom_champs: _vm.custom_champs,
              showHisto: true,
              histoChat: true
            },
            on: {
              closeDialog: _vm.dialogEditeurRemove,
              updateLead: _vm.updateLeadSubmit
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.dialogRemove,
            callback: function($$v) {
              _vm.dialogRemove = $$v
            },
            expression: "dialogRemove"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "primary white--text title" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("cap")(
                      _vm.$t("delete") +
                        " " +
                        _vm.$tc("leads", 1, { count: "" }) +
                        "?"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("v-card-text", [_vm._v(_vm._s(_vm.$t("msgDeleteLead")))]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: { click: _vm.cancelDialogRemove }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.submitDialogRemove }
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-389e5da7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-389e5da7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Leads.vue
// module id = null
// module chunks = 